import { render, staticRenderFns } from "./InsurerSideMenu.vue?vue&type=template&id=27feef32&scoped=true"
import script from "./InsurerSideMenu.vue?vue&type=script&lang=js"
export * from "./InsurerSideMenu.vue?vue&type=script&lang=js"
import style0 from "./InsurerSideMenu.vue?vue&type=style&index=0&id=27feef32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27feef32",
  null
  
)

export default component.exports